import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
// import './homeScreen.css'
import { FaBeer, FaFacebookF, FaInstagram, FaTwitter, FaSearch, FaEnvelopeOpen, FaHammer, FaToggleOn, FaThList, FaPhone } from 'react-icons/fa';
import styles from './FooterScreen.css';



const FooterScreen = (props) => {


    return (
        < >
            <section className='pt-5 pb-5' style={{borderTop:'1px solid black',backgroundColor:'black',}}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-sm-3'>
                            <ul style={{ listStyle: 'none' }}>
                                <li className='footerHeader'>Adress</li>
                                <li className='footerData'> Maheshwari Parameshwari Towers, 4-2-27, Kachiguda X Rd, Hyderabad, Telangana 500027</li>

                            </ul>
                        </div>
                        <div className='col-sm-3'>
                            <ul style={{ listStyle: 'none' }}>
                                <li className='footerHeader'>Services</li>
                                <li className='footerData'>Gifts</li>
                                <li className='footerData'>how it works</li>
                                <li className='footerData'>FAQ </li>
                                <li className='footerData'>classical Offer</li>
                            </ul>
                        </div>
                        <div className='col-sm-3'>
                            <ul style={{ listStyle: 'none' }}>
                                <li className='footerHeader'>About</li>
                                <li className='footerData'>The Oponion</li>
                                <li className='footerData'>Our Visions</li>
                                <li className='footerData'>Resonsible mode</li>
                                <li className='footerData'>Our comunity</li>
                                <li className='footerData'>Press</li>
                                <li className='footerData'>Clothing rental</li>
                            </ul>
                        </div>
                        <div className='col-sm-3'>
                            <ul style={{ listStyle: 'none' }}>
                                <li className='footerHeader'>Social</li>
                                <div style={{display:'flex'}}>
                                    <li className='footerSocialIocn fa fa-facebook'></li>
                                    <li className='footerSocialIocn fa fa-instagram' ></li>
                                    <li className='footerSocialIocn fa fa-twitter' ></li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default FooterScreen;